import {
    StyledCard,
    StyledCardHeader,
    StyledHeaderTitle,
    StyledJobsIcon,
    StyledJobsIconWrapper,
} from './JobsTableCard.styles';
import { Grid, Typography, useTheme } from '../../../base';
import { useTranslation } from 'react-i18next';
import { DashboardJobsTable } from '../../Tables';
const JobsTableCard = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <>
            <StyledCard>
                <StyledCardHeader>
                    <StyledHeaderTitle>
                        <StyledJobsIconWrapper
                            edge="end"
                            size="small"
                            onClick={() => {}}
                            disabled
                        >
                            <StyledJobsIcon name={'JobsIcon'} size={28} />
                        </StyledJobsIconWrapper>
                        <Typography variant="h6">
                            {t('dashboardPage.jobsTitle')}
                        </Typography>
                    </StyledHeaderTitle>
                </StyledCardHeader>
                <Grid
                    sx={{
                        paddingTop: theme.spacing(2),
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        height: '100%',
                    }}
                >
                    <DashboardJobsTable />
                </Grid>
            </StyledCard>
        </>
    );
};

export default JobsTableCard;
